import React, { useState, useEffect } from 'react';
import '../index.css';
import { searchRecordInAirTable, updateRecordInAirTable, createRecordInAirTable, savingFunc, fetchFlows } from '../functions.js/airTableDB';
import WorkflowBuilder from '../components/workflowBuilder';
import './editTable.css';

const FlowsBuilder = () => {
  const [gruppenVorlagen, setGruppenVorlagen] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchGroups = async () => {
        await fetchFlows(setGruppenVorlagen);
    };

    const fetchData = async () => {
      await Promise.all([fetchGroups()]);
      setIsLoading(false);
    };
    fetchData();
  }, []);

  if (isLoading) {
    return <p>Lade Daten...</p>;
  }

  return (
    <>
      <FlowsTable groups={gruppenVorlagen} setGroups={setGruppenVorlagen} />
    </>
  );
};

const FlowsTable = ({ groups, setGroups }) => {
    const [editedGroups, setEditedGroups] = useState({});
    const [originalGroups, setOriginalGroups] = useState({});
    const [editingGroup, setEditingGroup] = useState(null);
    const [newGroup, setNewGroup] = useState(null);
  
    // Neue Validierungsfunktion
    const isValidFlowName = (name) => {
      if (!name || name.trim() === '') return false;
      return /^[a-zA-Z0-9\s]+$/.test(name);
    };

    useEffect(() => {
      const initialEdits = {};
      const originalData = {};
      groups.forEach(group => {
        initialEdits[group.id] = { name: group.fields?.name || '' };
        originalData[group.id] = group.fields?.name || '';
      });
      setEditedGroups(initialEdits);
      setOriginalGroups(originalData);
    }, [groups]);
  
    const handleInputChange = (groupId, value) => {
      // Nur erlaubte Zeichen akzeptieren
      if (value === '' || /^[a-zA-Z0-9\s]*$/.test(value)) {
        setEditedGroups(prev => ({
          ...prev,
          [groupId]: { name: value }
        }));
      }
    };
  
    const hasChanges = (groupId) => {
      const newName = editedGroups[groupId]?.name || '';
      return newName !== originalGroups[groupId] && isValidFlowName(newName);
    };
  
    const handleSave = async (groupId) => {
      if (!hasChanges(groupId)) return;
      const updatedData = { name: editedGroups[groupId].name };
      await updateRecordInAirTable(groupId, updatedData, 'groups');
      setGroups(prev =>
        prev.map(group =>
          group.id === groupId ? { ...group, fields: { ...group.fields, ...updatedData } } : group
        )
      );
      setOriginalGroups(prev => ({
        ...prev,
        [groupId]: updatedData.name
      }));
      alert('Flow erfolgreich gespeichert!');
    };
  
    const handleDiscard = (groupId) => {
      setEditedGroups(prev => ({
        ...prev,
        [groupId]: { name: originalGroups[groupId] }
      }));
    };
  
    const toggleGroupBuilder = (groupId) => {
      setEditingGroup(editingGroup === groupId ? null : groupId);
    };
  
    const closeChartFunc = () => {
      setEditingGroup(null);
    };
  
    const handleNewSave = async () => {
      if (!newGroup?.name.trim() || !isValidFlowName(newGroup.name)) return;
      const newData = {
        name: newGroup.name,
        vorlageJSON: JSON.stringify({
            "lvl1_connections":[],"blocks":[]
        }),
        isTemplate: true
      };
      const result = await createRecordInAirTable(newData, 'flows');
  
      if (result) {
        setGroups(prev => [...prev, result]);
        setNewGroup(null);
        alert('Neuer Flow erfolgreich erstellt!');
      }
    };
  
    const handleNewCancel = () => {
      setNewGroup(null);
    };
  
    return (
      <div className="group-table">
        <h2>Workflow Vorlagen</h2>
        <div className="group-header">
          <span>Name</span>
          <span>Aktionen</span>
        </div>
  
        {groups.map(group => (
          <React.Fragment key={group.id}>
            <div className={`group-row ${editingGroup === group.id ? 'editing' : ''}`}>
              <input
                type="text"
                value={editedGroups[group.id]?.name || ''}
                onChange={(e) => handleInputChange(group.id, e.target.value)}
                disabled={editingGroup === group.id}
              />
              <div className="actions">
                {editingGroup !== group.id && (
                  <>
                    {hasChanges(group.id) && (
                      <>
                        <button className="btn save" onClick={() => handleSave(group.id)}>💾</button>
                        <button className="btn discard" onClick={() => handleDiscard(group.id)}>✖</button>
                      </>
                    )}
                    <button className="btn edit" onClick={() => toggleGroupBuilder(group.id)}>👀</button>
                  </>
                )}
              </div>
            </div>
  
            {editingGroup === group.id && (
              <div className="workflow-builder">
                <WorkflowBuilder
                  isTemplateEditing={true}
                  modus="editFlow"
                  templteRecID={group.id}
                  savingFunc={savingFunc}
                  closeChartFun={closeChartFunc}
                />
              </div>
            )}
          </React.Fragment>
        ))}
  
        {newGroup && (
          <div className="group-row new">
            <input
              type="text"
              placeholder="Neuer Flow..."
              value={newGroup.name}
              onChange={(e) => {
                const value = e.target.value;
                if (value === '' || /^[a-zA-Z0-9\s]*$/.test(value)) {
                  setNewGroup({ ...newGroup, name: value });
                }
              }}
            />
            <div className="actions">
              {newGroup?.name.trim() && isValidFlowName(newGroup.name) && (
                <>
                  <button className="btn save" onClick={handleNewSave}>💾</button>
                  <button className="btn discard" onClick={handleNewCancel}>✖</button>
                </>
              )}
            </div>
          </div>
        )}
  
        {!newGroup && (
          <button className="btn new-group" onClick={() => setNewGroup({ name: '' })}>
            + Neuer Flow
          </button>
        )}
      </div>
    );
  };

export default FlowsBuilder;
